import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageSquare } from "lucide-react";
import { Inbox } from "@/components/messages/Inbox";
import { Campaigns } from "@/components/messages/Campaigns";

export default function Messages() {
  const [params] = useSearchParams();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user.role === "admin";
  return (
    <div className="space-y-4" data-testid="messages-page">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-2xl bg-blue-700 flex items-center justify-center"><MessageSquare className="w-6 h-6 text-white" /></div>
        <div><h1 className="text-2xl sm:text-3xl font-bold text-slate-800">Messages</h1><p className="text-sm text-slate-500">Text customers via Flowroute · times shown in New York</p></div>
      </div>
      <Tabs defaultValue={params.get("tab") || "inbox"}>
        <TabsList>
          <TabsTrigger value="inbox" data-testid="messages-inbox-tab">Inbox</TabsTrigger>
          {isAdmin && <TabsTrigger value="campaigns" data-testid="messages-campaigns-tab">Campaigns</TabsTrigger>}
        </TabsList>
        <TabsContent value="inbox"><Inbox initialPhone={params.get("phone")} /></TabsContent>
        {isAdmin && <TabsContent value="campaigns"><Campaigns /></TabsContent>}
      </Tabs>
    </div>
  );
}
